import React, { useContext } from 'react'
import { MenuContext } from '../layout/global_layout'
import { StackView, Select, Icon, Button } from '@planningcenter/tapestry-react'
import { colors, breakpoints } from '../theme'
import useWindowWidth from '../utils/useWindowWidth'

const VersionSwitcher = ({ versions, version, onVersionChange }) => {
  const { setMobileMenuOpen } = useContext(MenuContext)
  const windowWidth = useWindowWidth()

  const handleInfoButtonClick = version => {
    onVersionChange(version)
    windowWidth < breakpoints.lg && setMobileMenuOpen(false)
  }

  return (
    <StackView
      axis="horizontal"
      alignment="center"
      paddingHorizontal={4}
      paddingVertical={1}
      style={{
        background: colors['grey-2'],
        borderBottom: `1px solid ${colors['grey-5']}`,
      }}
    >
      <Select
        value={version || 'none'}
        onChange={event => onVersionChange(event.value)}
        emptyValue="Select Version"
      >
        {versions.map(availableVersion => {
          return (
            <Select.Option
              key={availableVersion.id}
              value={availableVersion.id}
            >
              {availableVersion.id}
            </Select.Option>
          )
        })}
      </Select>
      {version ? (
        <Button
          onClick={() => handleInfoButtonClick(version)}
          marginLeft={1}
          theme="plain"
          size="sm"
          alignment="center"
        >
          <Icon name="general.outlinedInfoCircle" size="xs" marginRight={0.5} />
          Info
        </Button>
      ) : null}
    </StackView>
  )
}

export default VersionSwitcher
